<script>
    import Router from "svelte-spa-router";
    import routes from "./routes/routes.js";
    import { onMount, onDestroy } from "svelte";
    import { Capacitor } from "@capacitor/core";
    import { PushNotifications } from "@capacitor/push-notifications";
    import * as store from "./stores/store";
    import { get } from "svelte/store";
    import * as Common from "./utiles/common.util";
    import { LocalNotifications } from "@capacitor/local-notifications";
    import { App } from "@capacitor/app";
    import { Toast } from "@capacitor/toast";
    import { theme } from "./stores/store";
    import { Preferences } from "@capacitor/preferences";

    let backPressedTime = 0;
    let backHandler;
    let themeUnsubscribe;

    // 테마 변경 함수
    function applyTheme(t) {
        document.body.setAttribute('data-theme', t);
    }

    onMount(async () => {
        // 안드로이드 저장소에서 테마 불러오기
        const { value } = await Preferences.get({ key: "theme" });
        const savedTheme = value || "light";
        theme.set(savedTheme);
        applyTheme(savedTheme);
        
        // 스토어 값이 바뀔 때마다 테마 적용 및 저장
        themeUnsubscribe = theme.subscribe(async (value) => {
            applyTheme(value);
            await Preferences.set({ key: "theme", value: value });
        });

        backHandler = App.addListener("backButton", async () => {
            let currentPath = window.location.hash.replace(/^#/, "");

            if (
                currentPath !== "/" &&
                currentPath !== "/AsList" &&
                currentPath !== "/Login" &&
                currentPath !== "/PartnerList"
            ) {
                // 홈이 아니면 뒤로가기
                window.history.back();
            } else {
                const now = Date.now();
                if (now - backPressedTime < 2000) {
                    App.exitApp();
                } else {
                    backPressedTime = now;
                    await Toast.show({
                        text: "앱을 종료하려면 한 번 더 눌러주세요",
                        duration: "short",
                    });
                }
            }
        });
    });

    onDestroy(() => {
        // 컴포넌트 해제 시 리스너 제거
        if (backHandler) backHandler.remove();
        // 테마 구독 해제
        if (themeUnsubscribe) themeUnsubscribe();
    });

    async function registerForPush() {
        PushNotifications.addListener("registrationError", (err) => {
            console.error("등록 에러:", err);
        });

        // 푸시 알림 수신 (포그라운드 상태일 때)
        PushNotifications.addListener(
            "pushNotificationReceived",
            async (notification) => {
                // console.log("Push received in foreground:", notification);

                // Local Notification으로 직접 알림 띄우기
                await LocalNotifications.schedule({
                    notifications: [
                        {
                            title: notification.title || "알림",
                            body: notification.body || "",
                            id: new Date().getTime(),
                            schedule: { at: new Date(Date.now() + 100) },
                            channelId: "default_channel", // 꼭 지정!
                            sound: "default",
                        },
                    ],
                });
            },
        );

        PushNotifications.addListener(
            "pushNotificationActionPerformed",
            (action) => {
                // console.log("푸시 클릭:", action);
            },
        );
    }

    async function loadAccount() {
        const tokenRes = await Common.getStoredToken();
        const accountRes = await Common.getStoredAccount();

        if (tokenRes) store.jwt_token.set(tokenRes);
        if (accountRes) store.accountInfo.set(JSON.parse(accountRes));
    }

    onMount(async () => {
        loadAccount();

        if (Capacitor.isNativePlatform()) {
            const permStatus = await PushNotifications.requestPermissions();

            if (permStatus.receive === "granted") {
                console.log("알림 권한 허용됨");
                registerForPush();
                await PushNotifications.register();
            } else {
                console.log("알림 권한 거부됨");
                console.warn(
                    "푸시 권한이 거부되었습니다. 알림을 받을 수 없습니다.",
                );
                return;
            }

            PushNotifications.addListener("registration", (t) => {
                store.fcm_token.set(t.value);
            });

            // 등록 실패 처리 리스너는 등록 후에 추가해야 합니다.
            PushNotifications.addListener("registrationError", (err) => {
                console.error("FCM 등록 실패:", err);
            });

            PushNotifications.addListener("registration", (token) => {
                // console.log("Push registration token:", token.value);
            });

            PushNotifications.addListener(
                "pushNotificationReceived",
                (notification) => {
                    // console.log("Push received:", notification);
                },
            );

            PushNotifications.addListener(
                "pushNotificationActionPerformed",
                (action) => {
                    // console.log("Push action performed:", action);
                },
            );
        }
    });
</script>

<div class="app-shell">
    <Router {routes} />
</div>
